import { AutogenLayoutRetransmitStatusModal } from "./autogen/AutogenLayoutRetransmitStatusModal";

export class RetransmitStatusModal extends AutogenLayoutRetransmitStatusModal {
}
